import React, { useEffect, useState } from "react";

import styles from "../../../../styles/pages/user/qcagentdashboard/qcagent-submitted-videos-duplicated.module.scss";
import { Box } from "@mui/system";
import QcDashboardWrapper from "../../../../layout/wrapper/QcDashboradWrapper";
import { QcSubmittedVideosMenu } from "../../../../components/QcSubmittedVideosMenu/QcSubmittedVideosMenu";
import QcSubmittedVideosDuplicatesFilter from "../../../../components/QcSubmittedVideosDuplicatesFilter/QcSubmittedVideosDuplicatesFilter";
import QcSubmittedVideosDuplicatesTable from "../../../../components/QcSubmittedVideosDuplicatesTable/QcSubmittedVideosDuplicatesTable";
import { FetchQCVideos } from "../../../../api/functions/video.api";
import { useAppSelector } from "../../../../hooks/useAppSelector";
import { useQuery } from "react-query";

export default function QcSubmittedVideosDuplicates() {
  const { from, to } = useAppSelector((s) => s.qcSubmittedDuplicateSlice);

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const [page, setPage] = useState(1);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(["qc_duplication"], async () =>
    FetchQCVideos({
      page,
      from,
      to,
      manager_decision: 0,
      quality_team_decision: 6,
    })
  );

  const handlePageChange = (p) => {
    setPage(p);
  };

  useEffect(() => {
    refetchAgain();
  }, [page, fetchTrigger]);

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  //   console.log("data", data);

  return (
    <QcDashboardWrapper>
      <Box className={styles.reviewd_videos_wrapper}>
        <Box className={styles.reviewVideoMenu}>
          <QcSubmittedVideosMenu />
        </Box>

        <Box className={styles.reviewVideoTabMain}>
          <Box className={styles.single_rreview_tab}>
            <Box className={styles.reviewd_filter_wrap}>
              <QcSubmittedVideosDuplicatesFilter
                handleTriggreFetch={handleTriggreFetch}
                datas={data?.data}
              />
            </Box>

            <Box className={styles.approved_videos_table_wrap}>
              <QcSubmittedVideosDuplicatesTable
                datas={data?.data}
                handlePageChange={handlePageChange}
                page={page}
                handleTriggreFetch={handleTriggreFetch}
                loading={isLoading}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </QcDashboardWrapper>
  );
}
